<template>
	<router-view></router-view>
	<SessionKeepAliveSentinel v-if="isKeepAliveRoute" />
</template>

<script setup>
// DDAT-1660: 맵박스 렌더 화면에서만 세션 keep-alive 활성.
// 다른 페이지는 기본 자동 로그아웃 정책 유지(유휴 60분).
import { computed } from 'vue';
import { useRoute } from 'vue-router';

import { SESSION_KEEP_ALIVE_ROUTE_NAMES } from '@/constants/sessionKeepAliveRoutes';
import SessionKeepAliveSentinel from '@/views/component/SessionKeepAliveSentinel.vue';

const route = useRoute();
const isKeepAliveRoute = computed(() => SESSION_KEEP_ALIVE_ROUTE_NAMES.has(route.name));
</script>

<style>
</style>
